import React, { PureComponent } from 'react';
import ConfigurationFields from './ConfigurationFields';

class DefaultConfiguration extends PureComponent {
  render() {
    return <ConfigurationFields {...this.props} connectionCategory={'default'} />;
  }
}

export default DefaultConfiguration;
